import {
  takeEvery,
  call,
  put,
  select,
} from 'redux-saga/effects';

import {
  FETCH_GROUP_ORDER_REQUEST,
  fetchGroupOrderSucceed,
  setOrderStatusFromGOC,
  fetchOrderSummaryRequests,
  setAPIFailed,
  triggerAnalytics,
} from '../../actions';

import { getGroupOrder } from '../../../api/orderTrackerApi';

interface GroupOrderResponse {
  ordersNumbers: string[];
  orderStatusFromGOC: string;
  placedOn: string;
  isGOCFetched: boolean;
}

export function* groupOrderRequest(): Generator {
  const {
    orderSummary: { orderReference },
    caching: { orderId: cachedOrderId },
  } = (yield select((state: unknown) => state)) as {
    orderSummary: { orderReference: string };
    caching: { orderId?: string[] };
  };
  try {
    /* eslint-disable prefer-const */
    let {
      ordersNumbers,
      orderStatusFromGOC,
      placedOn,
      isGOCFetched,
    } = (yield call(getGroupOrder, orderReference)) as GroupOrderResponse;

    if (cachedOrderId) {
      ordersNumbers = ordersNumbers.filter((orderId: string) => orderId !== cachedOrderId[0]);
    }

    yield put(fetchGroupOrderSucceed({
      ordersNumbers,
      placedOn,
      isGOCFetched,
    }));
    yield put(setOrderStatusFromGOC({ orderStatusFromGOC }));
    yield put(fetchOrderSummaryRequests());
  } catch (error) {
    const { message } = error as { message: string };
    yield put(setAPIFailed({ isGeneralAPIFailed: true, isFetching: false, errorMessage: message }));
    yield put(triggerAnalytics());

    console.error('Group Orders Request:', message);
  }
}

export function* watchGroupOrders(): Generator {
  yield takeEvery(FETCH_GROUP_ORDER_REQUEST, groupOrderRequest);
}
